import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";

import { ICArea } from "../models/entities/icarea";
import { ICAreaFilter } from "../models/filters/icarea.filter";
import { ICAreaApi } from "../models/apis/icarea.api";
import { BaseDataService } from "./shared/base.data.service";
import { ResponseResult } from "../models/shared/response-result";
import { ICMetaDescriptionFilter } from "../models/filters/icmetadescription.filter";

@Injectable()
export class ICAreaService extends BaseDataService<
  ICArea,
  ICAreaFilter,
  ICAreaApi
> {
  public CurrentLevelChange$: EventEmitter<number>;

  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICArea);
    this.CurrentLevelChange$ = new EventEmitter();
    this.EndPoint = "icarea";
  }

  CreateWithLevel(
    filter: ICMetaDescriptionFilter,
    loader: boolean = true,
  ): Promise<ResponseResult<ICArea, ICAreaApi>> {
    return this.httpPost(`${this.Url}/createwithlevel`, filter, true, loader);
  }

  storeLevel(level: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      console.log(`[ICAreaService] storeLevel: Setting level to ${level}`);
      window.localStorage.setItem(this.StoreKey + "_LEVEL", level.toString());
      this.CurrentLevelChange$.emit(level);
      return resolve(true);
    });
  }

  getLevel(): Promise<number> {
    return new Promise((resolve, reject) => {
      const data = parseInt(
        window.localStorage.getItem(this.StoreKey + "_LEVEL"),
        10,
      );
      console.log(`[ICAreaService] getLevel: Read value ${data} from localStorage`);
      if (!isNaN(data)) {
        console.log(`[ICAreaService] getLevel: Returning ${data - 1}`);
        return resolve(data - 1);
      } else {
        console.log(`[ICAreaService] getLevel: Value is NaN, returning -1`);
        return resolve(-1);
      }
    });
  }
}
